import { useRef } from "react";
import { Box, Container } from "@mui/material";
import {
  StyledRoot,
  StyledMain,
  StyledContent,
  StyledSection,
  FormContainer,
  SignUp,
} from "../../pages/auth/login/Login.styles";
import Banner from "./Banner";
import Logo from "src/components/logo/Logo";
import useResponsive from "src/hooks/useResponsive";

const AuthLayout = ({ children }) => {
  const mdUp = useResponsive("up", "md");
  const myDivRef = useRef(null);

  return (
    <StyledRoot>
      <span ref={myDivRef} />
      <StyledMain>
        <Container
          maxWidth="sm"
          sx={{
            flex: 1,
            height: { xs: "100%", md: "100%" },
            minHeight: { xs: "100dvh", md: "auto" },
            display: "flex",
            flexDirection: "column",
            px: { xs: 2, sm: 3, md: 4, lg: 5 },
          }}
        >
          <StyledContent>
            <Box
              sx={{
                pt: { xs: 2, md: 4, lg: 5 },
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Logo href="/" />
              {!mdUp && <SignUp to="/signup">Sign Up</SignUp>}
            </Box>

            <FormContainer>{children}</FormContainer>
          </StyledContent>
        </Container>
      </StyledMain>

      {mdUp && (
        <StyledSection>
          <Banner />
        </StyledSection>
      )}
    </StyledRoot>
  );
};

export default AuthLayout;
